import React from 'react';
import { ResearchIntro } from '../components/research/ResearchIntro';
import { ResearchSkp } from '../components/research/ResearchSkp';
import { ResearchPriorities } from '../components/research/ResearchPriorities';
import { CognarchicFoundation } from '../components/research/CognarchicFoundation';
import { OperationalSystems } from '../components/research/OperationalSystems';
import { ResearchTesting } from '../components/research/ResearchTesting';
import { RelatedInitiative } from '../components/initiatives/RelatedInitiative';
export function ResearchPage() {
  return <>
      <ResearchIntro data-id="element-3151" data-mp="35gpm1lw4y11o" />
      <ResearchSkp data-id="element-3152" data-mp="35g7jy8mskslu" />
      <ResearchPriorities data-id="element-3153" data-mp="35hsfo1kuehla" />
      <RelatedInitiative name="Cognocracy" status="Concept Proposal" body="A proposed civic governance project that draws on this research, including the NCJI assessment model and its open questions." href="/projects/cognocracy" data-id="element-3154" data-mp="35j3hvwyn3haa" />
      <section aria-labelledby="related-governance" className="bg-white border-t border-line pt-20 lg:pt-24" data-id="element-3155" data-mp="yruj41houyce">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16" data-id="element-3156" data-mp="6vqqovz48vvf">
          <h2 id="related-governance" className="lg:col-span-5 font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight leading-tight" data-id="element-3157" data-mp="buabuu5vy3mq">
            Related governance research
          </h2>
          <p className="lg:col-span-7 text-lg text-ink-muted leading-relaxed" data-id="element-3158" data-mp="qkre2fqcgxko">
            The sections below explore how SyNeural’s architecture could relate
            to the Cognarchic State, a separate governance proposal. They are
            research material, not part of SyNeural’s current products or
            demos.
          </p>
        </div>
      </section>
      <CognarchicFoundation data-id="element-3159" data-mp="19k59z37mwidt" />
      <OperationalSystems data-id="element-3160" data-mp="19jvh97v7fx4f" />
      <ResearchTesting data-id="element-3161" data-mp="19ikf1cheqxff" />
    </>;
}